export default "//static.tradera.net/touchweb/static/output/images/category-art.39f75c7b.svg";